/** 与 App.vue 中 .ebk-mobile 断点一致（max-width: 992px） */
export default {
  data: function () {
    return { ebkMobile: false }
  },
  mounted: function () {
    if (typeof window === 'undefined' || !window.matchMedia) return
    this.ebkMq = window.matchMedia('(max-width: 992px)')
    this.ebkMobile = this.ebkMq.matches
    var self = this
    this._ebkOnMq = function () {
      self.ebkMobile = self.ebkMq.matches
    }
    this.ebkMq.addListener(this._ebkOnMq)
  },
  beforeDestroy: function () {
    if (this.ebkMq && this._ebkOnMq) {
      this.ebkMq.removeListener(this._ebkOnMq)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mobileBreakpoint.js